import React from 'react';
import styles from '../Withdrawal.module.css';

export const WithdrawalInfoSection = () => (
  <>
    <div className={styles.descriptionContainer}>
      <div className={styles.descriptionTitle}>How it works</div>
      <ol className={styles.descriptionContent}>
        <li className={styles.listStyle}>Please review your Cash Flow Facility withdrawal below.</li>
        <li className={styles.listStyle}>If you are satisfied, please accept the withdrawal.</li>
        <li className={styles.listStyle}>If you would like to change the withdrawal amount, please click the change amount button below.</li>
        <li className={styles.listStyle}>We will then email you a -copy of the Advance Agreement which includes a surety form and needs to be digitally signed by yourself.</li>
        <li className={styles.listStyle}>Funds will be transferred to your bank account as soon as the signed documents have been received.</li>
      </ol>
    </div>
  </>
);
